import {useParams} from "react-router-dom";

import React, {Suspense} from "react";
import './IndexPage.css';
import LoadingContainer from "../../../../Common/component/LoadingContainer/LoadingContainer";

/*
import DefaultDocuwiz from "../../../../Docuwiz-service/Default/index/Index"
import DemoDocuwiz from "../../../../Docuwiz-service/DEMO/index/Index"
import PostechDocuwiz from "../../../../Docuwiz-service/POSTECH/index/Index"
import BusanpaDocuwiz from "../../../../Docuwiz-service/BUSANPA/index/Index"
*/

const IndexPage = () =>
{
    const { openParam } = useParams() as { openParam: string };
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const ComponentIndex = React.lazy(()=>import(`../../../../Docuwiz-service/Customer/${serviceCode}/index/Index`))

    /*
    switch (serviceCode) {
        case 'DEFAULT':
            return (
                <DefaultDocuwiz
                    openParam={openParam}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        case 'DEMO':
            return (
                <DemoDocuwiz
                    openParam={openParam}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        case 'POSTECH':
            return (
                <PostechDocuwiz
                    openParam={openParam}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        case 'BUSANPA':
            return (
                <BusanpaDocuwiz
                    openParam={openParam}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        default:
            return <LoadingContainer message="초기데이터 불러오는 중..." />;
    }

     */

    return ComponentIndex ?    <Suspense fallback={<LoadingContainer message="Loading Modules.." />}>
            <ComponentIndex  openParam={openParam}  serviceCode={`${serviceCode}DC`} />
        </Suspense>
        : <LoadingContainer message="초기데이터 불러오는 중..." />;
}
export default IndexPage;